export default {"src":"https://fishbrain.com/_next/static/media/snapper.9be4460e.svg","height":115,"width":230,"blurWidth":0,"blurHeight":0};